export default __webpack_public_path__ + "static/media/azobe_wood.7740d440.png";